module.exports = __webpack_public_path__ + "img/1060344.b1a2f15f.png";